import React from 'react';
import PropTypes from 'prop-types';
import { variants, th } from 'style/theme';
import styled, { css } from 'styled-components';

const Label = styled.label`
  ${variants('variant', {
    light: css`
      color: ${th('colors.white')};
    `,
    dark: css`
      color: ${th('colors.black')};
    `
  })};

  ${variants('size', {
    medium: css`
      font-size: 16px;
    `,
    large: css`
      font-size: 18px;
    `,
    extralarge: css`
      font-size: 24px;
    `
  })};

  display: block;
  position: relative;
  font-weight: 700;
  margin-bottom: 0;
  letter-spacing: -0.5px;
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
`;

Label.propTypes = {
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['medium', 'large', 'extralarge'])
};

Label.defaultProps = {
  variant: 'dark',
  disabled: false,
  size: 'medium'
};

export default React.memo(Label);
